__turbopack_context__.v({
  "allPromos": "_0AckDq_allPromos",
  "cardMore": "_0AckDq_cardMore",
  "chevronUp": "_0AckDq_chevronUp",
  "featured": "_0AckDq_featured",
  "featuredBody": "_0AckDq_featuredBody",
  "featuredIcon": "_0AckDq_featuredIcon",
  "featuredIconGlyph": "_0AckDq_featuredIconGlyph",
  "featuredLink": "_0AckDq_featuredLink",
  "featuredText": "_0AckDq_featuredText",
  "featuredTitle": "_0AckDq_featuredTitle",
  "notes": "_0AckDq_notes",
  "notice": "_0AckDq_notice",
  "noticeHeader": "_0AckDq_noticeHeader",
  "noticeHeaderIcon": "_0AckDq_noticeHeaderIcon",
  "noticeIcon": "_0AckDq_noticeIcon",
  "noticeText": "_0AckDq_noticeText",
  "noticeUpdated": "_0AckDq_noticeUpdated",
  "pointSale": "_0AckDq_pointSale",
  "pointSaleIcon": "_0AckDq_pointSaleIcon",
  "pointSaleText": "_0AckDq_pointSaleText",
  "promo": "_0AckDq_promo",
  "promoBody": "_0AckDq_promoBody",
  "promoGrid": "_0AckDq_promoGrid",
  "promoIcon": "_0AckDq_promoIcon",
  "promoLabel": "_0AckDq_promoLabel",
  "promoText": "_0AckDq_promoText",
  "promoTitle": "_0AckDq_promoTitle",
  "section": "_0AckDq_section",
  "sectionBeforeAbout": "_0AckDq_sectionBeforeAbout",
  "srHeading": "_0AckDq_srHeading",
  "wrap": "_0AckDq_wrap",
});
